window.addEventListener('load', () => {
  const atelierSections = document.querySelectorAll('.atelier');
  if (!atelierSections.length || typeof Swiper === 'undefined') return;

  for (const section of atelierSections) {
    const cardEl = section.querySelector('.card-wrapper');
    if (!cardEl || cardEl.swiper) continue;

    const paginationEl = section.querySelector('.swiper-pagination');
    const nextEl = section.querySelector('.custom-next');
    const prevEl = section.querySelector('.custom-prev');

    new Swiper(cardEl, {
      loop: true,
      speed: 900,
      spaceBetween: 24,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      pagination: {
        el: paginationEl,
        clickable: true
      },
      navigation: {
        nextEl,
        prevEl
      },
      breakpoints: {
        0: {
          slidesPerView: 1.15,
          spaceBetween: 12
        },
        360: {
          slidesPerView: 1.4,
          spaceBetween: 14
        },
        480: {
          slidesPerView: 1.6,
          spaceBetween: 14
        },
        577: {
          slidesPerView: 2.2,
          spaceBetween: 16
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 18
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 20
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 24
        },
        1920: {
          slidesPerView: 4,
          spaceBetween: 28
        },
        2560: {
          slidesPerView: 4.35,
          spaceBetween: 32
        }
      }
    });
  }
});
